import React, { Fragment, Component } from 'react';
import Auth from 'j-toker';
import { connect } from 'react-redux';
import { submit, destroy } from 'redux-form';

import { browserHistory } from 'react-router';
import MediaQuery from 'react-responsive';

import { RenderIfToggleOn, RenderIfToggleOff } from 'components/shared/ToggleRenderer';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import NotificationPreferencesDialog from 'components/tenant_app/components/notification_preferences/NotificationPreferencesDialog';
import AutopaySettings from 'components/tenant_app/components/payments/autopay/AutopaySettings';
import ToDoComponent from './components/tenant_dashboard/ToDoComponent';
import RequestMaintenanceDialog from './components/tenant_dashboard/RequestMaintenanceDialog';
import OutstandingMaintenanceDialog from './components/tenant_dashboard/OutstandingMaintenance';
import AllTransactions from './components/tenant_dashboard/AllTransactions';
import PaymentReceipts from 'components/tenant_app/components/payments/receipts/PaymentReceipts';
import TenantPaymentOptions from 'components/tenant_app/components/payments/TenantPaymentOptions';
import DownloadDocuments from './components/tenant_dashboard/DownloadDocuments';
import TenancyInfo from './components/tenant_dashboard/TenancyInfo';
import PropertyFAQInfo from './components/tenant_dashboard/PropertyFAQInfo';
import AddExtraApplicants from './components/tenant_dashboard/AddExtraApplicants';
import PromotionsDrawer from './components/PromotionsDrawer';
import ProfileDrawer from './components/ProfileDrawer';
import AmenityDrawer from './components/AmenityDrawer';
import NoticesDrawer from './components/NoticesDrawer';
import TwoFactorAuth from 'components/shared/TwoFactorAuth';
import PoweredByYuhu from 'components/shared/PoweredByYuhu';
import SocialMediaLinks from 'components/ui/SocialMediaLinks';
import AutopaySetupWarning from 'components/tenant_app/components/payments/paymentDialog/AutopaySetupWarning';
import ViewEditRentersInsuranceDialog from './components/tenant_dashboard/ViewEditRentersInsuranceDialog';
import { NoticePDFDialog } from './components/NoticePDFDialog';

import { colors } from 'helpers/ColorHelper';
import { formatMoney } from 'helpers/Formatter';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';
import { createMuiTheme } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core';

import {
  postUserProfileDetails,
  getTenantProfile,
  payments,
  getAmenities,
  getBuildingCommunity,
  boardwalkPayments,
  createTenantDocument,
  deleteTenantAssetDocument,
  editTenantAssetDocument,
} from 'actions/tenantProfileActions';
import {
  getTenantMaintenanceRequest,
  getTenantMaintenanceRequestPendingSync,
  getTenantMaintenanceRooms,
  createTenantMaintenanceRequest,
} from 'actions/tenantMaintenanceActions';
import {
  getUserPreferences,
  updateUserNotificationPreferences,
  getUserNotificationPreferences,
} from 'actions/userTypesActions';
import { explosionCelebration, showFailure } from 'actions/notificationActions';
import * as dashboard from 'actions/dashboardActions';
import { toggleChatDrawer } from 'actions/chatActions';
import { twoFactorAuth } from 'actions/authenticationActions';
import { getDocuments } from 'actions/downloadActions';
import { getMaintenanceCategories, getMaintenanceLocations } from 'actions/maintenanceActions';

import { localize } from 'react-localize-redux';

import { featureEnabled } from 'helpers/ToggleBot';
import { AccentColor } from 'helpers/AccentColorHelper';
import { deepDiver } from 'helpers/utilities';
import { drawerStyle } from 'helpers/tableHelpers';
import { hostIsCapreit, hostIsBoardwalk, hostIsBgoResidents } from 'helpers/CurrentWindowLocation';

import DocumentsIcon from '@material-ui/icons/DescriptionTwoTone';
import EnvelopeIcon from '@material-ui/icons/MessageTwoTone';
import InfoIcon from '@material-ui/icons/InfoTwoTone';
import LinkIcon from '@material-ui/icons/Link';
import PropertyInfoIcon from '@material-ui/icons/BusinessTwoTone';

import ReceiptIcon from '@material-ui/icons/ReceiptTwoTone';
import ViewMaintenanceIcon from '@material-ui/icons/AssignmentTurnedInTwoTone';
import MaintenanceIcon from '@material-ui/icons/BuildTwoTone';
import MonetizationIcon from '@material-ui/icons/MonetizationOnTwoTone';
import AmenityIcon from '@material-ui/icons/EventAvailableTwoTone';
import EventsIcon from '@material-ui/icons/LocalActivityTwoTone';
import NotificationsIcon from '@material-ui/icons/NotificationImportantTwoTone';
import PromotionsIcon from '@material-ui/icons/LocalOfferTwoTone';
import ProfileIcon from '@material-ui/icons/PersonTwoTone';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import EmailIcon from '@material-ui/icons/EmailTwoTone';
import {
  getTranslatedString,
  getCurrentLocale,
  getLandlordVerbiageOrTranslatedString,
} from 'helpers/i18n';
import { toFriendlyDateString } from 'helpers/Formatter';

import styled from 'styled-components';

const StyledTileContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledTile = styled.div`
  flex: 1 50%;
  max-width: 50%;
  text-align: center;
  margin: 10px 0;
  padding: 0 10px;
`;

const StyledSocialMediaLinks = styled(SocialMediaLinks)`
  margin-top: 40px;
`;

const SYNC_REQUEST_POLL_INTERVAL_IN_MS = 10000;

let style = {
  badge: {
    textAlign: 'center',
    fontSize: '11px',
    lineHeight: '15px',
    borderRadius: '3px',
    color: '#fff',
    display: 'inline-block',
    padding: '1px 6px',
    margin: '5px auto',
    cursor: 'pointer',
    fontFamily: 'Circular-Bold',
  },
  transaction_card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    padding: '20px',
    boxShadow:
      'rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0) 0px 0px 4px 0px, rgba(0, 0, 0, 0.12) 0px 0px 0px -4px',
  },
  buttonIcon: {
    color: '#a7a7a7',
    marginRight: '10px',
    position: 'absolute',
    fontSize: '180px',
    left: '60%',
    top: '7px',
    opacity: '0.1',
  },
};

const APPLICATION_STATUS = {
  4: 'PENDING_UNIT_ASSIGNMENT',
};

const TenantDashboard = connect(
  (store) => {
    return {
      currentTenant: store.dashboard.currentTenant,
      tenantOverview: store.dashboard.tenantOverview,
      tenancyInfo: store.tenantProfile.tenancyInfo,
      hasPoll: store.dashboard.hasPoll,
      showPage: store.authentication.showPage,
      todoData: store.todo.todoData,
      badgeIconForEvents: store.dashboard.badgeIconForEvents,
      hasApplication: store.dashboard.hasApplication,
      coapplicantsInApplication: store.dashboard.coapplicantsInApplication,
      showChatDrawer: store.chat.toggleChatDrawer,
      buildingCommunity: store.tenantProfile.buildingCommunity,
      activeConversation: store.chat.activeConversation,
      verificationRequired: store.authentication.twoAuthVerification.verificationRequired,
      verificationStep: store.authentication.twoAuthVerification.verificationStep,
      maintenanceTickets: store.tenantMaintenance.tickets,
      documents: store.downloads.documents,
      enableInsurancePurchaseInTenantApp:
        store.userTypes.userPreferences.enable_insurance_purchase_in_tenant_app,
      address: store.dashboard.address,
      leaseStartDate: store.dashboard.leaseStartDate,
      verbiages: store.userTypes.verbiages,
      portalLinks: store.dashboard.portalLinks,
      bannerMessage: store.dashboard.bannerMessage,
      stepIndex: store.applicationStatus.stepIndex,
      landlordMaintenaceRequestLink: store.dashboard.landlordMaintenaceRequestLink,
    };
  },
  {
    ...dashboard,
    postUserProfileDetails,
    getTenantProfile,
    payments,
    getTenantMaintenanceRequest,
    getTenantMaintenanceRequestPendingSync,
    explosionCelebration,
    getTenantMaintenanceRooms,
    createTenantMaintenanceRequest,
    getAmenities,
    getUserPreferences,
    getUserNotificationPreferences,
    updateUserNotificationPreferences,
    submit,
    destroy,
    getBuildingCommunity,
    toggleChatDrawer,
    twoFactorAuth,
    boardwalkPayments,
    createTenantDocument,
    getDocuments,
    deleteTenantAssetDocument,
    editTenantAssetDocument,
    getMaintenanceCategories,
    getMaintenanceLocations,
    showFailure,
  }
)(
  class TenantDashboard extends Component {
    constructor(props) {
      super(props);
      this.state = {
        createMaintenanceRequest: false,
        viewOpenMaintenanceRequests: false,
        viewPaymentReceiptsOLD: false,
        toggleLeaseDetails: false,
        viewDocuments: false,
        toggleMessaging: false,
        showAmenityDrawer: false,
        showPromotionsDrawer: false,
        showAutopaySetup: false,
        showProfileDrawer: false,
        notificationPrefencesOpen: false,
        openNotices: false,
        openEvents: false,
        verificationOpen: true,
        createTicketStep: 1,
        createTicketFormData: {},
        paymentReceiptsDialogOpen: false,
        viewRentersInsurance: false,
        payDialogOpen: false,
        paymentDetails: {},
        togglePropertyFAQDetails: false,
        paymentHold: false,
        lockedAmount: false,
        activeAutopayWarningOpen: false,
        showMaintenanceWaiver: true,
      };
    }

    componentDidMount = async () => {
      this.props.getTenancyStatus();
      this.props.getTenantMaintenanceRequest();
      this.props.getTenantMaintenanceRooms();
      this.props.getAmenities();
      this.props.getUserPreferences();
      this.props.getBuildingCommunity();
      this.props.getMaintenanceCategories();
      this.props.getMaintenanceLocations();
    };

    componentWillUnmount() {
      clearInterval(this.ticketsPendingSync);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (
        nextProps.todoData !== this.props.todoData ||
        nextProps.tenancyInfo !== this.props.tenancyInfo
      ) {
        this.props.payments();
      }
    }

    base64String = (base64String) => {
      this.setState({
        base64String: base64String,
      });
    };

    toggleNoticeDialog = () => {
      this.setState({
        base64String: null,
      });
    };

    submitCreateTicket = (formData) => {
      if (
        this.state.createTicketStep === 1 &&
        featureEnabled('ui.create_service_request.permission_to_enter')
      ) {
        this.setState({
          createTicketStep: 2,
          createTicketFormData: formData,
        });
      } else if (
        this.state.createTicketStep === 2 ||
        !featureEnabled('ui.create_service_request.permission_to_enter')
      ) {
        const finalFormData = {
          ...this.state.createTicketFormData,
          ...formData,
        };
        return this.props.createTenantMaintenanceRequest(finalFormData).then(() => {
          this.props.getTenancyStatus();
          this.toggleDialog();
          this.setState({
            createTicketStep: 1,
            createTicketFormData: {},
            showMaintenanceWaiver: true,
          });

          if (
            this.state.viewOpenMaintenanceRequests &&
            this.props.tenantOverview.use_external_ticket_numbers
          ) {
            this.ticketsPendingSync = this.pollSyncingRequests();
          }

          window.gtag('event', 'create_service_request', {
            event_category: 'engagement',
            event_label: 'resident_portal',
          });
        });
      }
    };

    toggleOnMaintenanceWaiver = () => {
      this.setState({
        showMaintenanceWaiver: true,
      });
    };

    toggleOffMaintenanceWaiver = () => {
      this.setState({
        showMaintenanceWaiver: false,
      });
    };

    pollSyncingRequests = () => {
      return setInterval(() => {
        if (
          this.props.tenantOverview.use_external_ticket_numbers &&
          this.props.maintenanceTickets.some((ticket) => !ticket.ticket_number)
        ) {
          const blankTicketNumbers = this.props.maintenanceTickets
            .filter((ticket) => !ticket.ticket_number)
            .map((ticket) => ticket.id);
          this.props.getTenantMaintenanceRequestPendingSync(blankTicketNumbers);
        } else {
          clearInterval(this.ticketsPendingSync);
        }
      }, SYNC_REQUEST_POLL_INTERVAL_IN_MS);
    };

    routeToCommunity = () => {
      browserHistory.push('/community');
    };

    deleteTenantDocument = (assetId) => {
      this.props.deleteTenantAssetDocument(assetId).then(() => {
        this.props.getDocuments();
      });
    };

    editTenantDocument = (assetId, expiryDate) => {
      this.props.editTenantAssetDocument(assetId, expiryDate).then(() => {
        this.props.getDocuments();
      });
    };

    toggleDialog = () => {
      if (!featureEnabled('ui.tenant_portal.maintenance')) return;
      this.setState({
        createMaintenanceRequest: !this.state.createMaintenanceRequest,
        createTicketStep: this.state.createMaintenanceRequest ? 1 : this.state.createTicketStep,
        createTicketFormData: this.state.createMaintenanceRequest
          ? {}
          : this.state.createTicketFormData,
      });
      window.gtag(
        'event',
        `toggle_service_requests_dialog_${this.state.createMaintenanceRequest}`,
        {
          event_category: 'engagement',
          event_label: 'resident_portal',
        }
      );
    };

    toggleOpenMaintenanceDialog = () => {
      if (!featureEnabled('ui.tenant_portal.maintenance')) return;
      if (!this.state.viewOpenMaintenanceRequests) {
        this.props.getTenantMaintenanceRequest().then(() => {
          if (
            this.props.tenantOverview.use_external_ticket_numbers &&
            this.props.maintenanceTickets.some((ticket) => !ticket.ticket_number)
          ) {
            this.ticketsPendingSync = this.pollSyncingRequests();
          }
        });
      } else {
        clearInterval(this.ticketsPendingSync);
      }

      this.setState((prevState) => ({
        viewOpenMaintenanceRequests: !prevState.viewOpenMaintenanceRequests,
      }));
      window.gtag(
        'event',
        `toggle_view_open_service_requests_${this.state.viewOpenMaintenanceRequests}`,
        {
          event_category: 'engagement',
          event_label: 'resident_portal',
        }
      );
    };

    toggleOpenPaymentReceiptDialog = () => {
      if (this.props.tenantOverview.payment_provider !== 'bambora') {
        // viewPaymentReceiptsOLD represents the old version of payment receipts
        this.setState({ viewPaymentReceiptsOLD: !this.state.viewPaymentReceiptsOLD });
        return;
      }

      if (!this.state.paymentReceiptsDialogOpen) {
        // TODO: PAYMENTS, do this generic fetching of payment
        this.props.boardwalkPayments('1_month');
      }
      this.setState((prevState) => ({
        paymentReceiptsDialogOpen: !prevState.paymentReceiptsDialogOpen,
      }));
    };

    toggleOpenDocumentsDialog = () => {
      this.setState((prevState) => ({
        viewDocuments: !prevState.viewDocuments,
      }));
      window.gtag('event', `toggle_documents_${this.state.viewDocuments}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    toggleRentersInsurance = () => {
      this.setState((prevState) => ({
        viewRentersInsurance: !prevState.viewRentersInsurance,
      }));
    };

    toggleLeaseDetailsDialog = () => {
      this.setState((prevState) => ({
        toggleLeaseDetails: !prevState.toggleLeaseDetails,
      }));
      window.gtag('event', `toggle_leases_${this.state.toggleLeaseDetails}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    togglePropertyFAQDetailsDialog = () => {
      this.setState((prevState) => ({
        togglePropertyFAQDetails: !prevState.togglePropertyFAQDetails,
      }));
      window.gtag('event', `toggle_property_faq_${this.state.togglePropertyFAQDetails}`, {
        event_category: 'property_faq',
        event_label: 'resident_portal',
      });
    };

    openAmenities = () => {
      this.setState((prevState) => ({ showAmenityDrawer: !prevState.showAmenityDrawer }));
      window.gtag('event', `toggle_amenities_${this.state.showAmenityDrawer}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    openPromotions = () => {
      this.setState((prevState) => ({ showPromotionsDrawer: !prevState.showPromotionsDrawer }));
      window.gtag('event', `toggle_promotions_${this.state.showPromotionsDrawer}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    openTwoFactorVerification = (formData = {}, onSuccessfulVerification) => {
      this.setState({ verificationOpen: true });
      this.props.twoFactorAuth(formData, onSuccessfulVerification);
      window.gtag('event', `2factor_${this.state.verificationOpen}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    closeTwoFactorVerification = () => {
      this.setState((prevState) => ({ verificationOpen: !prevState.verificationOpen }));
      window.gtag('event', `2factor_${this.state.verificationOpen}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    openProfile = () => {
      this.setState((prevState) => ({ showProfileDrawer: !prevState.showProfileDrawer }));
      window.gtag('event', `toggle_profile_${this.state.showProfileDrawer}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    togglePayment = () => {
      const { showAutopaySetup, activeAutopayWarningOpen } = this.state;

      const { external_autopay_setup_on_lease } = this.props.tenantOverview;

      // If lease already has autopay setup externally, show warning -- BWALK ONLY AT THIS TIME
      const warningNotOpen = !showAutopaySetup && !activeAutopayWarningOpen;
      const externalAutopaySetup = external_autopay_setup_on_lease === true && hostIsBoardwalk();
      if (warningNotOpen && externalAutopaySetup) {
        this.setState({ activeAutopayWarningOpen: true });
        return;
      }

      if (this.state.showAutopaySetup === true) {
        this.props.destroy('pad_details');
      }
      this.setState((prevState) => ({
        showAutopaySetup: !prevState.showAutopaySetup,
        activeAutopayWarningOpen: false,
      }));
      window.gtag('event', `toggle_payment_${this.state.showAutopaySetup}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    togglePayDialog = (paymentDetails = {}) => {
      const { todoData } = this.props;

      if (this.state.payDialogOpen) {
        this.setState({
          payDialogOpen: false,
          paymentDetails: {},
        });
        return;
      }

      const outstandingToDo =
        todoData && todoData.find((todo) => todo['event_type'] === 'OutstandingBalance');

      const yardiLedgerToDo =
        todoData && todoData.find((todo) => todo['event_type'] === 'YardiLedger');

      const ApplicationDepositToDo =
        todoData && todoData.find((todo) => todo['event_type'] === 'ApplicationDeposit');

      const lastYardiLedgerEntry =
        yardiLedgerToDo && yardiLedgerToDo.ledger[yardiLedgerToDo.ledger.length - 1];

      let amountOwing = 0;
      let applicationId = null;
      let paymentType = 'general';
      let usesSecurityDepositSubAccountFlow = false;
      if (ApplicationDepositToDo && paymentDetails && paymentDetails.total_application_payable) {
        amountOwing = paymentDetails.total_application_payable;
        applicationId = ApplicationDepositToDo.application_id;
        paymentType = 'deposit';
        usesSecurityDepositSubAccountFlow = ApplicationDepositToDo.uses_security_sub_accounts;
      } else if (lastYardiLedgerEntry) {
        amountOwing = lastYardiLedgerEntry.balance;
      } else if (outstandingToDo) {
        amountOwing = outstandingToDo['outstanding_balance'];
      }

      paymentDetails = {
        ...paymentDetails,
        outstanding_balance: amountOwing,
        lease_application_id: applicationId,
        yardiLedger: yardiLedgerToDo && yardiLedgerToDo.ledger,
        payment_type: paymentType,
      };
      this.setState({
        payDialogOpen: true,
        paymentDetails: paymentDetails,
        lockedAmount: paymentType === 'deposit' && usesSecurityDepositSubAccountFlow,
      });
    };

    toggleCustomMaintenanceRequestLink = () => {
      window.open(this.props.landlordMaintenaceRequestLink, '_blank');
    };

    toggleNotificationsDialog = async () => {
      if (!this.state.notificationPrefencesOpen) {
        await this.props.getUserNotificationPreferences();
      }
      this.setState((prevState) => ({
        notificationPrefencesOpen: !prevState.notificationPrefencesOpen,
      }));
      window.gtag('event', `toggle_notifications_${this.state.notificationPrefencesOpen}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    toggleNotices = () => {
      this.setState((prevState) => ({ openNotices: !prevState.openNotices }));
      window.gtag('event', `toggle_notices_${this.state.openNotices}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    toggleEvents = () => {
      if (!deepDiver(this.props.buildingCommunity, 'events')) return;
      if (deepDiver(this.props.buildingCommunity, 'events').length === 0) return;

      this.setState((prevState) => ({ openEvents: !prevState.openEvents }));
      window.gtag('event', `toggle_events_${this.state.openEvents}`, {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    openChat = () => {
      this.props.unreadMessages(deepDiver(this.props.activeConversation, 'id'), 0);
      this.props.toggleChatDrawer(!this.props.showChatDrawer);
      window.gtag('event', 'open_chat', {
        event_category: 'engagement',
        event_label: 'resident_portal',
      });
    };

    numberOfTiles = () => {
      let numTiles = 5;

      if (
        !deepDiver(this.props.buildingCommunity, 'events') ||
        deepDiver(this.props.buildingCommunity, 'events').length === 0
      ) {
        numTiles -= 1;
      }

      if (!this.props.tenantOverview.show_messaging) {
        numTiles -= 1;
      }

      if (!featureEnabled('ui.tenant_portal.maintenance')) {
        numTiles -= 1;
      }

      if (!this.props.tenantOverview.payments_module_active) {
        numTiles -= 1;
      }

      return numTiles;
    };

    renderBannerMessage = () => {
      const { bannerMessage } = this.props;
      if (!bannerMessage || !bannerMessage[getCurrentLocale()]) return null;

      return (
        <div
          style={{
            padding: '15px 30px',
            backgroundColor: bannerMessage['color'] || colors.BANNER_GREEN,
            color: 'white',
            fontSize: '18px',
            fontFamily: 'Circular-Bold',
            textAlign: 'center',
          }}
        >
          {bannerMessage[getCurrentLocale()]}
        </div>
      );
    };

    render() {
      const isMobile = window.matchMedia('(max-width: 750px)').matches;
      if (this.props.tenantOverview.portal_active === false) {
        return (
          <div
            className="body"
            role="main"
            style={{ backgroundColor: '#fdfdfd', marginTop: '65px' }}
          >
            {this.renderBannerMessage()}
            {this.renderPaymentOptions()}
            <div className="centers" style={{ maxWidth: '1000px', margin: 'auto' }}>
              <div style={{ padding: '20px 0px' }}>
                <h3 style={{ margin: '0 0 7px 0' }}>
                  {getLandlordVerbiageOrTranslatedString('nameGreeting', {
                    name: Auth.user[this.props.greetingNameType] || Auth.user.first_name,
                  })}
                </h3>
                {this.renderPortalNotActive()}
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="body" role="main" style={{ backgroundColor: '#fdfdfd', marginTop: '65px' }}>
          {this.renderBannerMessage()}

          <div className="centers" style={{ maxWidth: '1000px', margin: 'auto' }}>
            <div style={{ padding: '20px 0px' }}>
              <h3 style={{ margin: '0 0 7px 0' }}>
                {getLandlordVerbiageOrTranslatedString('nameGreeting', {
                  name: Auth.user[this.props.greetingNameType] || Auth.user.first_name,
                })}
              </h3>
              {this.renderAmenityDrawer()}
              {this.renderPromotionsDrawer()}
              {this.renderProfileDrawer()}
              {this.renderNoticesDrawer()}
              {this.renderEventsDrawer()}
              {this.renderWelcomeApplicant()}
              {this.renderAddExtraApplicants()}
              {this.renderPaymentOptions()}

              <NoticePDFDialog
                isOpen={!!this.state.base64String}
                fullScreen={isMobile}
                base64String={this.state.base64String}
                toggleDialog={this.toggleNoticeDialog}
              />

              {this.state.notificationPrefencesOpen && (
                <NotificationPreferencesDialog
                  isOpen={this.state.notificationPrefencesOpen}
                  toggleDialog={this.toggleNotificationsDialog}
                />
              )}

              <RenderIfToggleOn toggle="ui.tenant_portal.maintenance">
                <RequestMaintenanceDialog
                  toggleDialog={this.toggleDialog}
                  isOpen={this.state.createMaintenanceRequest}
                  step={this.state.createTicketStep}
                  submitForm={this.submitCreateTicket}
                  toggleOnMaintenanceWaiver={this.toggleOnMaintenanceWaiver}
                  toggleOffMaintenanceWaiver={this.toggleOffMaintenanceWaiver}
                  showMaintenanceWaiver={this.state.showMaintenanceWaiver}
                />
              </RenderIfToggleOn>

              <RenderIfToggleOn toggle="ui.tenant_portal.maintenance">
                <OutstandingMaintenanceDialog
                  toggleDialog={this.toggleOpenMaintenanceDialog}
                  toggleNewMaintenanceDialog={this.toggleDialog}
                  isOpen={this.state.viewOpenMaintenanceRequests}
                />
              </RenderIfToggleOn>

              <DownloadDocuments
                toggleDialog={this.toggleOpenDocumentsDialog}
                isOpen={this.state.viewDocuments}
              />

              <TenancyInfo
                toggleDialog={this.toggleLeaseDetailsDialog}
                isOpen={this.state.toggleLeaseDetails}
              />

              <PropertyFAQInfo
                toggleDialog={this.togglePropertyFAQDetailsDialog}
                isOpen={this.state.togglePropertyFAQDetails}
                propertyFAQ={deepDiver(this.props.tenantOverview, 'property_faq')}
                contactDetails={deepDiver(this.props.tenantOverview, 'contact_details')}
              />

              <TwoFactorAuth
                toggleDialog={this.closeTwoFactorVerification}
                isOpen={this.props.verificationRequired && this.state.verificationOpen}
                onSuccessfulVerification={this.openProfile}
                handleVerification={this.openTwoFactorVerification}
                hasBouncedEmail={deepDiver(this.props.tenantOverview, 'bounced_email')}
              />

              <ViewEditRentersInsuranceDialog
                dialogOpen={this.state.viewRentersInsurance}
                toggleDialog={this.toggleRentersInsurance}
                createTenantDocument={this.props.createTenantDocument}
                deleteDocument={this.deleteTenantDocument}
                editDocument={this.editTenantDocument}
                insuranceDetails={this.props.documents['docType.rentersInsurance']}
                canPurchaseInsurance={this.props.enableInsurancePurchaseInTenantApp}
                address={this.props.address}
                tenantOverview={this.props.tenantOverview}
                leaseStartDate={this.props.leaseStartDate}
                showFailure={this.props.showFailure}
              />

              {this.renderDashboardOverview()}
              {this.renderToDoComponent()}

              {this.renderOptionsMenu()}
            </div>
            {this.props.links && (
              <StyledSocialMediaLinks showConnectWithUsText={true} links={this.props.links} />
            )}
            <PoweredByYuhu />
            <div style={{ height: '100px' }} />
          </div>
        </div>
      );
    }

    renderPaymentOptions = () => {
      const outstandingToDo =
        this.props.todoData &&
        this.props.todoData.find((todo) => todo['event_type'] === 'OutstandingBalance');

      const yardiLedgerToDo =
        this.props.todoData &&
        this.props.todoData.find((todo) => todo['event_type'] === 'YardiLedger');

      const lastYardiLedgerEntry =
        yardiLedgerToDo && yardiLedgerToDo.ledger[yardiLedgerToDo.ledger.length - 1];
      let amountOwing = this.props.tenantOverview && this.props.tenantOverview.amount_owing;
      if (lastYardiLedgerEntry) {
        amountOwing = formatMoney(lastYardiLedgerEntry.balance);
      } else if (outstandingToDo) {
        amountOwing = formatMoney(outstandingToDo['outstanding_balance']);
      }

      const ableToMakePayment =
        this.props.tenantOverview.use_payment_platform &&
        this.props.tenantOverview.payments_module_active;

      return (
        <Fragment>
          <AutopaySettings
            togglePayment={this.togglePayment}
            isOpen={this.state.showAutopaySetup}
          />
          <AutopaySetupWarning
            handleCancel={() => this.setState({ activeAutopayWarningOpen: false })}
            handleContinue={this.togglePayment}
            open={this.state.activeAutopayWarningOpen}
            paymentType="autopay"
          />
          <AllTransactions
            yardiBased={!!yardiLedgerToDo}
            yardiLedger={yardiLedgerToDo && yardiLedgerToDo.ledger}
            toggleDialog={this.toggleOpenPaymentReceiptDialog}
            isOpen={this.state.viewPaymentReceiptsOLD}
            amountOwing={amountOwing}
            handleMakePayment={this.togglePayDialog}
            ableToMakePayment={ableToMakePayment}
          />

          <PaymentReceipts
            toggleDialog={this.toggleOpenPaymentReceiptDialog}
            isOpen={this.state.paymentReceiptsDialogOpen}
            togglePayDialog={this.togglePayDialog}
            hasEnablePaymentModule={this.props.tenantOverview.payments_module_active}
            amountOwing={amountOwing}
          />

          <TenantPaymentOptions
            toggleAutopay={this.togglePayment}
            togglePayDialog={this.togglePayDialog}
            payDialogOpen={this.state.payDialogOpen}
            paymentDetails={this.state.paymentDetails}
            tenantOverview={this.props.tenantOverview}
            yardiBased={!!yardiLedgerToDo}
            lockedAmount={this.state.lockedAmount}
          />
        </Fragment>
      );
    };

    renderToDoComponent = () => (
      <div className="row">
        <ToDoComponent
          toggleAutopay={this.togglePayment}
          tenantOverview={this.props.tenantOverview}
          togglePayDialog={this.togglePayDialog}
          payDialogOpen={this.state.payDialogOpen}
          paymentDetails={this.state.paymentDetails}
        />
      </div>
    );

    renderWelcomeApplicant = () => {
      if (!this.props.tenantOverview.show_welcome_message) return;
      const welcomeMessageOptions = {
        serviceRequest: getTranslatedString('dashboard.portalWelcomeMessage'),
        requestForMaintenance: getTranslatedString('dashboard.portalWelcomeMessageRFM'),
      };
      return (
        <p style={{ fontSize: '16px', margin: '20px 0 10px', textAlign: 'justify' }}>
          <i className="em em-wave" />
          {'  '}
          <b style={{ fontFamily: 'Circular-Bold' }}>
            {' '}
            <TenantResidentVerbiageHelper
              translatedTenant={getTranslatedString('dashboard.portalWelcomeMessageGreeting')}
              translatedResident={getTranslatedString(
                'dashboard.portalWelcomeMessageGreetingResident'
              )}
            />
          </b>
          <i className="em em-wave" />
          {'  '}
          {serviceRequestOptions(welcomeMessageOptions)}
        </p>
      );
    };

    renderAddExtraApplicants = () => {
      if (
        !this.props.hasApplication ||
        !this.props.coapplicantsInApplication ||
        this.props.tenantOverview.active_lease ||
        APPLICATION_STATUS[this.props.stepIndex] === 'PENDING_UNIT_ASSIGNMENT'
      )
        return null;

      return <AddExtraApplicants />;
    };

    renderPortalNotActive = () => (
      <Fragment>
        {this.renderLeaseSubmittedInactivePortalMessage()}
        {this.renderToDoComponent()}
      </Fragment>
    );

    renderLeaseSubmittedInactivePortalMessage = () => {
      if (this.props.tenantOverview.show_welcome_message) return;
      if (!this.props.tenantOverview.active_lease) return;

      return (
        <p style={{ fontSize: '16px', margin: '20px 0 10px', textAlign: 'justify' }}>
          <i className="em em-wave" />
          {'  '}
          <b style={{ fontFamily: 'Circular-Bold' }}>
            {' '}
            {getTranslatedString('portal.leaseSubmitted')}{' '}
          </b>
          <i className="em em-wave" />
          {'  '}
          {getTranslatedString('portal.portalInactive')}
        </p>
      );
    };

    renderCommunity = () => {
      if (
        !Auth.user.most_recent_lease_has_amenities &&
        deepDiver(this.props.buildingCommunity, 'events') &&
        deepDiver(this.props.buildingCommunity, 'events').length === 0 &&
        deepDiver(this.props.buildingCommunity, 'notices') &&
        deepDiver(this.props.buildingCommunity, 'notices').length === 0 &&
        !Auth.user.active_lease_has_promotions
      )
        return;

      return (
        <div className="row">
          <MediaQuery query="(min-device-width: 700px)">
            <h3 style={{ margin: '10px 0 20px 0', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {getTranslatedString('menu.community')}
            </h3>
          </MediaQuery>
          <MediaQuery query="(max-device-width: 700px)">
            <h3 style={{ margin: '25px 0 20px', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {getTranslatedString('menu.community')}
            </h3>
            <hr />
          </MediaQuery>
          {this.renderAmenityBooking()}
          {this.renderEvents()}
          {this.renderNotices()}
          {this.renderPromotions()}
        </div>
      );
    };

    renderInformationAndPayments = () => (
      <div className="row">
        <MediaQuery query="(min-device-width: 700px)">
          <h3 style={{ margin: '10px 0 20px 0', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
            {getTranslatedString('menu.infoAndPayments')}
          </h3>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 700px)">
          <h3 style={{ margin: '25px 0 20px', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
            {getTranslatedString('menu.infoAndPayments')}
          </h3>
          <hr />
        </MediaQuery>
        {this.renderRentReceiptButton()}
        {this._renderViewDocuments()}
        {this.renderViewLeaseDetails()}
        {this.renderBuildingFAQDetails()}
        {this.renderProfile()}
        {this.renderInsuranceDocument()}
      </div>
    );

    _renderViewDocuments = () => {
      if (hostIsCapreit()) return;
      return (
        <OptionsButton
          icon={<DocumentsIcon style={style.buttonIcon} />}
          onClick={this.toggleOpenDocumentsDialog}
          buttonVerbiage={getTranslatedString('portalDocuments.viewDocuments')}
          subVerbiage={getTranslatedString('portalDocuments.viewDocumentsDetails')}
          ctaVerbiage={getTranslatedString('portalDocuments.viewDocumentsCTA')}
        />
      );
    };

    renderMessaging = () => (
      <div className="row">
        <MediaQuery query="(min-device-width: 700px)">
          <h3 style={{ margin: '10px 0 20px 0', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
            {getTranslatedString('messaging')}
          </h3>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 700px)">
          <h3 style={{ margin: '25px 0 20px', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
            {getTranslatedString('messaging')}
          </h3>
          <hr />
        </MediaQuery>
        {this.renderMessageLandlordButton()}
        {this.renderMessagingPreferences()}
      </div>
    );

    renderPortalLinks = () => {
      if (!Auth.user.has_active_lease) return;
      if (deepDiver(this.props.tenantOverview, 'property_type') === 'industrial') return;

      let portalLinks = this.props.portalLinks;
      if (!portalLinks) return;

      return (
        <div className="row">
          <MediaQuery query="(min-device-width: 700px)">
            <h3 style={{ margin: '10px 0 20px 0', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {getTranslatedString('portal.portalLinks')}
            </h3>
          </MediaQuery>
          <MediaQuery query="(max-device-width: 700px)">
            <h3 style={{ margin: '25px 0 20px', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {getTranslatedString('portal.portalLinks')}
            </h3>
            <hr />
          </MediaQuery>
          {this.renderPortalLinksOptions(portalLinks)}
        </div>
      );
    };

    renderServiceRequests = () => {
      if (!Auth.user.has_active_lease) return;
      if (!Auth.user.move_in) return;
      if (!featureEnabled('ui.tenant_portal.maintenance')) return;

      const maintenanceRequestsOptions = {
        serviceRequest: getTranslatedString('maintenanceRequests'),
        requestForMaintenance: getTranslatedString('maintenanceRequestsRFM'),
      };

      return (
        <div className="row">
          <MediaQuery query="(min-device-width: 700px)">
            <h3 style={{ margin: '10px 0 20px 0', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {serviceRequestOptions(maintenanceRequestsOptions)}
            </h3>
          </MediaQuery>
          <MediaQuery query="(max-device-width: 700px)">
            <h3 style={{ margin: '25px 0 20px', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {serviceRequestOptions(maintenanceRequestsOptions)}
            </h3>
            <hr />
          </MediaQuery>
          {this.renderCreateServiceRequestButton()}
          {this.renderViewServiceRequestsButton()}
        </div>
      );
    };

    renderAutopaySignup = () => {
      if (!this.props.tenantOverview.use_payment_platform) return;
      if (this.props.tenantOverview.has_active_pad) return;
      if (!this.props.tenantOverview.payments_module_active) return;

      return (
        <div className="row">
          <MediaQuery query="(min-device-width: 700px)">
            <h3 style={{ margin: '10px 0 20px 0', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {getTranslatedString('autopay.signUp')}
            </h3>
          </MediaQuery>
          <MediaQuery query="(max-device-width: 700px)">
            <h3 style={{ margin: '25px 0 20px', fontFamily: 'Circular-Bold', fontSize: '20px' }}>
              {getTranslatedString('autopay.signUp')}
            </h3>
            <hr />
          </MediaQuery>
          {this.renderAutopayOptionButton()}
        </div>
      );
    };

    renderOptionsMenu = () => {
      if (!this.props.tenantOverview.active_lease) return;

      return (
        <div className="row">
          <h3> {getTranslatedString('portal.WhatWouldYouLIkeToDo')} </h3>

          <div className="row" style={{ marginTop: '15px' }}>
            <MediaQuery query="(max-device-width: 700px)">
              <div style={{ marginTop: '-15px' }} />
            </MediaQuery>
            {this.renderPortalLinks()}
            <RenderIfToggleOn toggle="payments.autopay">
              {' '}
              {this.renderAutopaySignup()}
            </RenderIfToggleOn>
            {this.renderServiceRequests()}
            {this.renderMessaging()}
            {this.renderCommunity()}
            {this.renderInformationAndPayments()}
          </div>
        </div>
      );
    };

    renderBuildingFAQDetails = () => {
      if (
        !deepDiver(this.props.tenantOverview, 'property_faq') &&
        deepDiver(this.props.tenantOverview, 'contact_details').length === 0
      )
        return;
      if (hostIsCapreit()) return;
      if (hostIsBoardwalk()) return;

      return (
        <OptionsButton
          icon={<PropertyInfoIcon style={style.buttonIcon} />}
          onClick={this.togglePropertyFAQDetailsDialog}
          buttonVerbiage={getTranslatedString('portalLeaseDetails.viewPropertyFAQ')}
          subVerbiage={getTranslatedString('portalLeaseDetails.viewPropertyFAQDetails')}
          ctaVerbiage={getTranslatedString('portalLeaseDetails.viewPropertyFAQCTA')}
        />
      );
    };

    renderViewLeaseDetails = () => {
      if (deepDiver(this.props.tenantOverview, 'property_type') === 'industrial') return;
      if (hostIsCapreit()) return;

      return (
        <OptionsButton
          icon={<InfoIcon style={style.buttonIcon} />}
          onClick={this.toggleLeaseDetailsDialog}
          buttonVerbiage={getTranslatedString('portalLeaseDetails.viewLeases')}
          subVerbiage={getTranslatedString('portalLeaseDetails.viewLeaseDetails')}
          ctaVerbiage={getTranslatedString('portalLeaseDetails.viewLeaseCTA')}
        />
      );
    };

    renderEvents = () => {
      if (!deepDiver(this.props.buildingCommunity, 'events')) return;
      if (deepDiver(this.props.buildingCommunity, 'events').length === 0) return;

      return (
        <OptionsButton
          icon={<EventsIcon style={style.buttonIcon} />}
          onClick={this.toggleEvents}
          buttonVerbiage={getTranslatedString('portalCommunityDetails.viewEvents')}
          subVerbiage={getTranslatedString('portalCommunityDetails.viewEventsDetails')}
          ctaVerbiage={getTranslatedString('portalCommunityDetails.viewEventsCTA')}
        />
      );
    };

    renderNotices = () => {
      if (!deepDiver(this.props.buildingCommunity, 'notices')) return;
      if (deepDiver(this.props.buildingCommunity, 'notices').length === 0) return;

      let viewNoticesVerbiage = getTranslatedString('portalCommunityDetails.viewNotices');

      if (
        deepDiver(
          this.props.verbiages,
          `residentPortal.portalCommunityDetails.viewNotices.${getCurrentLocale()}`
        )
      ) {
        viewNoticesVerbiage = deepDiver(
          this.props.verbiages,
          `residentPortal.portalCommunityDetails.viewNotices.${getCurrentLocale()}`
        );
      }
      return (
        <OptionsButton
          icon={<NotificationsIcon style={style.buttonIcon} />}
          onClick={this.toggleNotices}
          buttonVerbiage={viewNoticesVerbiage}
          subVerbiage={getTranslatedString('portalCommunityDetails.viewNoticesDetails')}
          ctaVerbiage={getTranslatedString('portalCommunityDetails.viewNoticesCTA')}
        />
      );
    };

    renderProfile = () => {
      return (
        <OptionsButton
          icon={<ProfileIcon style={style.buttonIcon} />}
          onClick={() => this.openTwoFactorVerification({}, this.openProfile)}
          buttonVerbiage={getTranslatedString('portal.viewProfile')}
          subVerbiage={getTranslatedString('portal.viewProfileDetails')}
          ctaVerbiage={getTranslatedString('portal.viewProfileCTA')}
        />
      );
    };

    renderMessagingPreferences = () => (
      <OptionsButton
        icon={<EmailIcon style={style.buttonIcon} />}
        onClick={this.toggleNotificationsDialog}
        buttonVerbiage={getTranslatedString('portal.viewMessagingPreferences')}
        subVerbiage={getTranslatedString('portal.viewMessagingPreferencesDetails')}
        ctaVerbiage={getTranslatedString('view')}
      />
    );

    renderInsuranceDocument = () => {
      if (!this.props.documents['docType.rentersInsurance']) return;

      return (
        <OptionsButton
          icon={<DocumentsIcon style={style.buttonIcon} />}
          onClick={this.toggleRentersInsurance}
          buttonVerbiage={getTranslatedString('landlordPortal.viewRentersInsurance')}
          subVerbiage={getTranslatedString('landlordPortal.viewRentersInsuranceDetail')}
          ctaVerbiage={getTranslatedString('landlordPortal.viewrentersInsuranceCta')}
        />
      );
    };

    renderPromotions = () => {
      if (!Auth.user.active_lease_has_promotions) return;

      return (
        <OptionsButton
          icon={<PromotionsIcon style={style.buttonIcon} />}
          onClick={this.openPromotions}
          buttonVerbiage={getTranslatedString('portalCommunityDetails.viewPromotions')}
          subVerbiage={getTranslatedString('portalCommunityDetails.viewPromotionsDetails')}
          ctaVerbiage={getTranslatedString('portalCommunityDetails.viewPromotionsCTA')}
        />
      );
    };

    renderAmenityBooking = () => {
      if (!Auth.user.most_recent_lease_has_amenities) return;
      return (
        <OptionsButton
          icon={<AmenityIcon style={style.buttonIcon} />}
          onClick={this.openAmenities}
          buttonVerbiage={getTranslatedString('portalAmenities.bookAmenity')}
          subVerbiage={getTranslatedString('portalAmenities.bookAmenityDetails')}
          ctaVerbiage={getTranslatedString('portalAmenities.bookAmenityCTA')}
        />
      );
    };

    renderAutopayOptionButton = () => {
      if (!this.props.tenantOverview.use_payment_platform) return;
      if (this.props.tenantOverview.has_active_pad) return;
      if (!this.props.tenantOverview.payments_module_active) return;

      let buttonVerbiage = getTranslatedString('portalAutopay.setupAutopay');
      let subVerbiage = getTranslatedString('portalAutopay.setupAutopayDetails');
      let ctaVerbiage = getTranslatedString('portalAutopay.setupAutopayCTA');
      if (!hostIsBoardwalk()) {
        buttonVerbiage = getTranslatedString('portalAutopay.setupPreAuthorizedPayment');
        subVerbiage = getTranslatedString('portalAutopay.setupPreAuthorizedPaymentDetails');
        ctaVerbiage = getTranslatedString('portalAutopay.setupAutopayCTA');

        if (this.props.tenantOverview.external_autopay_is_setup) {
          buttonVerbiage = getTranslatedString('portalAutopay.resubmitAutopay');
          subVerbiage = getTranslatedString('portalAutopay.autopayLastSubmitted', {
            lastSubmittedDate: toFriendlyDateString(
              this.props.tenantOverview.external_autopay_last_setup_date,
              { language: getCurrentLocale() }
            ),
          });
          ctaVerbiage = getTranslatedString('portalAutopay.resubmitAutopayCTA');
        }
      }

      return (
        <OptionsButton
          icon={<MonetizationIcon style={style.buttonIcon} />}
          onClick={this.togglePayment}
          buttonVerbiage={buttonVerbiage}
          subVerbiage={subVerbiage}
          ctaVerbiage={ctaVerbiage}
        />
      );
    };

    renderMessageLandlordButton = () => {
      if (!this.props.tenantOverview.show_messaging) return;

      return (
        <OptionsButton
          icon={<EnvelopeIcon style={style.buttonIcon} />}
          onClick={this.openChat}
          buttonVerbiage={getTranslatedString('portalMessaging.messageLandlord')}
          subVerbiage={getTranslatedString('portalMessaging.messageLandlordDetails')}
          ctaVerbiage={getTranslatedString('portalMessaging.messageLandlordCTA')}
        />
      );
    };

    renderCreateServiceRequestButton = () => {
      if (!Auth.user.has_active_lease) return;
      if (!Auth.user.move_in) return;

      const buttonVerbiageOptions = {
        serviceRequest: getTranslatedString('portalRequests.createServiceRequest'),
        requestForMaintenance: getTranslatedString('portalRequests.createServiceRequestRFM'),
      };

      const subVerbiageOptions = {
        serviceRequest: getTranslatedString('portalRequests.createServiceRequestDetails'),
        requestForMaintenance: getTranslatedString('portalRequests.createServiceRequestDetailsRFM'),
      };

      return (
        <OptionsButton
          icon={<MaintenanceIcon style={style.buttonIcon} />}
          onClick={
            this.props.landlordMaintenaceRequestLink
              ? this.toggleCustomMaintenanceRequestLink
              : this.toggleDialog
          }
          buttonVerbiage={serviceRequestOptions(buttonVerbiageOptions)}
          subVerbiage={serviceRequestOptions(subVerbiageOptions)}
          ctaVerbiage={getTranslatedString('portalRequests.createServiceRequestCTA')}
        />
      );
    };

    renderViewServiceRequestsButton = () => {
      if (!Auth.user.has_active_lease) return;
      if (hostIsBgoResidents()) return;
      if (!Auth.user.move_in) return;

      const buttonVerbiageOptions = {
        serviceRequest: getTranslatedString('portalRequests.viewServiceRequest'),
        requestForMaintenance: getTranslatedString('portalRequests.viewServiceRequestRFM'),
      };

      const subVerbiageOptions = {
        serviceRequest: getTranslatedString('portalRequests.viewServiceRequestDetails'),
        requestForMaintenance: getTranslatedString('portalRequests.viewServiceRequestDetailsRFM'),
      };
      return (
        <OptionsButton
          icon={<ViewMaintenanceIcon style={style.buttonIcon} />}
          onClick={this.toggleOpenMaintenanceDialog}
          buttonVerbiage={serviceRequestOptions(buttonVerbiageOptions)}
          subVerbiage={serviceRequestOptions(subVerbiageOptions)}
          ctaVerbiage={getTranslatedString('portalRequests.viewServiceRequestCTA')}
        />
      );
    };

    renderRentReceiptButton = () => {
      if (hostIsCapreit()) return;

      // we only show rent receipts if client is yardi based or payments module is turn on
      const showReceipts =
        this.props.tenantOverview.yardi_based || this.props.tenantOverview.payments_module_active;

      if (!showReceipts) return;

      return (
        <OptionsButton
          icon={<ReceiptIcon style={style.buttonIcon} />}
          onClick={this.toggleOpenPaymentReceiptDialog}
          buttonVerbiage={getTranslatedString('portalPayments.viewRentReceipts')}
          subVerbiage={getTranslatedString('portalPayments.viewRentReceiptsDetails')}
          ctaVerbiage={getTranslatedString('portalPayments.viewRentReceiptsCTA')}
        />
      );
    };

    renderPortalLinksOptions = (portalLinks) => {
      if (!portalLinks) return;

      return portalLinks.map((link) => {
        let url = link.url;
        if (typeof url != 'string' && !(url instanceof String)) {
          url = url[getCurrentLocale()] || url['en'] || url;
        }

        const onClick = () => {
          let browserWindow = window.open();
          browserWindow.location.href = url;
        };

        return (
          <OptionsButton
            icon={<LinkIcon style={{ ...style.buttonIcon, marginBottom: '-10px' }} />}
            onClick={onClick}
            buttonVerbiage={link.title[getCurrentLocale()]}
            subVerbiage={link.body[getCurrentLocale()]}
            ctaVerbiage={link.ctaButton[getCurrentLocale()]}
          />
        );
      });
    };

    renderDashboardOverview = () => {
      if (!this.props.tenantOverview.active_lease) return;

      const showMaintenanceTile =
        Auth.user.has_active_lease &&
        !hostIsBgoResidents() &&
        featureEnabled('ui.tenant_portal.maintenance') &&
        Auth.user.move_in;

      return (
        <StyledTileContainer>
          {this.renderAutopayTile()}
          {showMaintenanceTile &&
            !hostIsBgoResidents() &&
            this.renderDashboardOverviewTile(
              this.props.tenantOverview.open_maintenance_tickets,
              getTranslatedString('dashboard.openMaintenanceTickets'),
              this.toggleOpenMaintenanceDialog
            )}
          {this.renderEventsTile()}
          {this.renderNoticesTile()}
          {this.renderUnreadMessages()}
        </StyledTileContainer>
      );
    };

    renderEventsTile = () => {
      if (!deepDiver(this.props.buildingCommunity, 'events')) return;
      if (deepDiver(this.props.buildingCommunity, 'events').length === 0) return;

      return this.renderDashboardOverviewTile(
        this.props.tenantOverview.number_of_events,
        getTranslatedString('dashboard.upcomingEvents'),
        this.toggleEvents
      );
    };

    renderNoticesTile = () => {
      let numberOfNotices = 0;
      if (deepDiver(this.props.buildingCommunity, 'notices')) {
        numberOfNotices = deepDiver(this.props.buildingCommunity, 'notices').length;
      }

      return this.renderDashboardOverviewTile(
        numberOfNotices,
        getTranslatedString('dashboard.notices'),
        this.toggleNotices,
        this.numberOfTiles() === 5
      );
    };

    renderUnreadMessages = () => {
      if (!this.props.tenantOverview.show_messaging) return;

      return this.renderDashboardOverviewTile(
        this.props.tenantOverview.unread_messages,
        getTranslatedString('todo.unreadMessages'),
        this.openChat
      );
    };

    renderDashboardOverviewTile = (
      overviewHighlight,
      itemDescription,
      onClickAction,
      hasOffset = false
    ) => {
      return (
        <StyledTile>
          <Card style={{ padding: '10px 0 0', cursor: 'pointer' }} onClick={onClickAction}>
            <CardContent style={{ position: 'relative' }}>
              <h3 style={{ margin: '5px 0 0', fontSize: '21px' }}>{overviewHighlight}</h3>
              {this.renderStyledSeperator()}
              <p style={{ fontFamily: 'Circular', margin: 0 }}>{itemDescription}</p>
            </CardContent>
          </Card>
        </StyledTile>
      );
    };

    renderAutopayBadge = () => {
      if (!this.props.tenantOverview.use_payment_platform) return;
      if (!this.props.tenantOverview.payments_module_active) return;

      let autopayStatus = 'pending';
      let autopayVerbiage = getTranslatedString('dashboard.autopayIsOff');
      const hasExternalAutopay = this.props.tenantOverview.external_autopay_is_setup;
      const externalAutopayStatus = this.props.tenantOverview.external_autopay_status;

      if (
        this.props.tenantOverview.has_active_pad ||
        (hasExternalAutopay && externalAutopayStatus === 'approved')
      ) {
        autopayStatus = 'autopay-active';
        autopayVerbiage = getTranslatedString('dashboard.autopayIsOn');
      }

      if (hasExternalAutopay && externalAutopayStatus === 'pending') {
        autopayStatus = 'autopay-active';
        autopayVerbiage = getTranslatedString('dashboard.autopayIsPending');
      }

      if (externalAutopayStatus === 'cancelled') {
        autopayStatus = 'autopay-cancelled';
        autopayVerbiage = getTranslatedString('dashboard.autopayWasCancelled');
      }

      return (
        <span className={autopayStatus} style={style.badge}>
          {autopayVerbiage}
        </span>
      );
    };

    renderStyledSeperator = (displayOverride = false) => {
      if (displayOverride) return;

      return (
        <hr
          style={{
            maxWidth: '35px',
            margin: '12px auto',
            borderTop: `3px solid ${AccentColor()}`,
          }}
        />
      );
    };

    renderAutopayTile = () => {
      // TODO Payments, figure out where the click should go too!
      if (hostIsBgoResidents() || hostIsCapreit()) return;
      if (!this.props.tenantOverview.payments_module_active) return;

      const renderAutopayStyleSeperator =
        this.props.tenantOverview.use_payment_platform &&
        this.props.tenantOverview.payments_module_active;

      const outstandingToDo = this.props.todoData.find(
        (todo) => todo['event_type'] === 'OutstandingBalance'
      );
      const yardiLedgerToDo = this.props.todoData.find(
        (todo) => todo['event_type'] === 'YardiLedger'
      );

      const lastYardiLedgerEntry =
        yardiLedgerToDo && yardiLedgerToDo.ledger[yardiLedgerToDo.ledger.length - 1];

      let amountOwing = this.props.tenantOverview.amount_owing;
      if (lastYardiLedgerEntry) {
        amountOwing = formatMoney(lastYardiLedgerEntry.balance);
      } else if (outstandingToDo) {
        amountOwing = formatMoney(outstandingToDo['outstanding_balance']);
      }

      return (
        <StyledTile>
          <Card
            style={{ padding: '10px 0 0', cursor: 'pointer' }}
            onClick={this.toggleOpenPaymentReceiptDialog}
          >
            <CardContent style={{ position: 'relative' }}>
              <h3 style={{ margin: '5px 0 0', fontSize: '21px' }}>{amountOwing}</h3>
              <RenderIfToggleOn toggle="payments.autopay">
                {this.renderAutopayBadge()}
                {this.renderStyledSeperator(renderAutopayStyleSeperator)}
              </RenderIfToggleOn>
              <RenderIfToggleOff toggle="payments.autopay">
                {this.renderStyledSeperator(false)}
              </RenderIfToggleOff>

              <p style={{ fontFamily: 'Circular', margin: 0 }}>
                {getTranslatedString('dashboard.amountOwing')}
              </p>
            </CardContent>
          </Card>
        </StyledTile>
      );
    };

    renderAmenityDrawer = () => {
      let customDrawerStyle = { ...drawerStyle };
      customDrawerStyle.overrides.MuiDrawer.paper = {
        height: '100% !important',
        backgroundColor: colors.LIGHTEST_GRAY,
      };
      return (
        <MuiThemeProvider theme={createMuiTheme(customDrawerStyle)}>
          <Drawer open={this.state.showAmenityDrawer} onClose={this.openAmenities} anchor="left">
            <AmenityDrawer toggleDrawer={this.openAmenities} />
          </Drawer>
        </MuiThemeProvider>
      );
    };

    renderEventsDrawer = () => {
      let customDrawerStyle = { ...drawerStyle };
      customDrawerStyle.overrides.MuiDrawer.paper = {
        height: '100% !important',
        backgroundColor: colors.LIGHTEST_GRAY,
      };
      return (
        <MuiThemeProvider theme={createMuiTheme(customDrawerStyle)}>
          <Drawer open={this.state.openEvents} onClose={this.toggleEvents} anchor="left">
            <NoticesDrawer
              toggleDrawer={this.toggleEvents}
              buildingEventsOrNotices={deepDiver(this.props.buildingCommunity, 'events')}
              headerVerbiage={getTranslatedString('menu.events')}
            />
          </Drawer>
        </MuiThemeProvider>
      );
    };

    renderNoticesDrawer = () => {
      let customDrawerStyle = { ...drawerStyle };
      customDrawerStyle.overrides.MuiDrawer.paper = {
        height: '100% !important',
        backgroundColor: colors.LIGHTEST_GRAY,
      };
      return (
        <MuiThemeProvider theme={createMuiTheme(customDrawerStyle)}>
          <Drawer open={this.state.openNotices} onClose={this.toggleNotices} anchor="left">
            <NoticesDrawer
              toggleDrawer={this.toggleNotices}
              buildingEventsOrNotices={deepDiver(this.props.buildingCommunity, 'notices')}
              headerVerbiage={getTranslatedString('menu.notices')}
              base64String={this.base64String}
            />
          </Drawer>
        </MuiThemeProvider>
      );
    };

    renderProfileDrawer = () => {
      let customDrawerStyle = { ...drawerStyle };
      customDrawerStyle.overrides.MuiDrawer.paper = {
        height: '100% !important',
        backgroundColor: colors.LIGHTEST_GRAY,
      };
      return (
        <MuiThemeProvider theme={createMuiTheme(customDrawerStyle)}>
          <Drawer open={this.state.showProfileDrawer} onClose={this.openProfile} anchor="left">
            <ProfileDrawer toggleDrawer={this.openProfile} />
          </Drawer>
        </MuiThemeProvider>
      );
    };

    renderPromotionsDrawer = () => {
      let customDrawerStyle = { ...drawerStyle };
      customDrawerStyle.overrides.MuiDrawer.paper = {
        height: '100% !important',
        backgroundColor: colors.LIGHTEST_GRAY,
      };
      return (
        <MuiThemeProvider theme={createMuiTheme(customDrawerStyle)}>
          <Drawer
            open={this.state.showPromotionsDrawer}
            onClose={this.openPromotions}
            anchor="left"
          >
            <PromotionsDrawer toggleDrawer={this.openPromotions} />
          </Drawer>
        </MuiThemeProvider>
      );
    };
  }
);

class OptionsButton extends Component {
  resetStyle = () => {
    style.buttonIcon = {
      display: 'inline-block',
      marginRight: '10px',
      fontSize: '33px',
      color: 'inherit',
    };
  };

  getAriaLabel = () => {
    if (this.props.buttonVerbiage && this.props.subVerbiage && this.props.ctaVerbiage) {
      return (
        this.props.buttonVerbiage + ' ' + this.props.subVerbiage + ' ' + this.props.ctaVerbiage
      );
    }

    return 'Click to see more';
  };

  render() {
    return (
      <Fragment>
        <MediaQuery query="(min-device-width: 768px)">
          <div
            className="col-sm-4 col-md-6 col-xs-12"
            style={{ marginBottom: '20px', cursor: 'pointer' }}
            onClick={this.props.onClick}
          >
            <Card style={{ padding: '10px 0 21px', minHeight: '190px' }}>
              <CardContent style={{ position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {this.props.icon}
                  <h4 style={{ display: 'inline-block', fontSize: '19px', width: '300px' }}>
                    {this.props.buttonVerbiage}
                  </h4>
                </div>
                <Typography component="p" style={{ color: colors.MEDIUM_GRAY }}>
                  {this.props.subVerbiage}
                </Typography>
              </CardContent>
              <CardActions style={{ padding: '8px 19px 2px' }}>
                <Button
                  size="medium"
                  style={{ color: 'white', backgroundColor: AccentColor() }}
                  aria-label={this.getAriaLabel()}
                  fullWidth
                >
                  {this.props.ctaVerbiage || 'create'}
                </Button>
              </CardActions>
            </Card>
          </div>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 767px)">
          <div
            className="row"
            style={{ cursor: 'pointer', padding: '10px 0' }}
            onClick={this.props.onClick}
          >
            {this.resetStyle()}
            <div className="col-xs-2" style={{ marginTop: '15px', color: AccentColor() }}>
              {this.props.icon}
            </div>
            <div className="col-xs-10">
              <h4 style={{ fontSize: '17px' }}>{this.props.buttonVerbiage}</h4>
              <p>{this.props.subVerbiage}</p>
            </div>
          </div>
          <hr />
        </MediaQuery>
      </Fragment>
    );
  }
}

const mapStateToProps = (store) => ({
  links: store.tenantProfile.buildingCommunity.social_media_links,
  greetingNameType: store.userTypes.greetingNameType,
});

export default localize()(connect(mapStateToProps, null)(TenantDashboard));
